export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Getting Started
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-5">
              What Is a Sugargoo Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                A <strong>Sugargoo Spreadsheet</strong> is a structured product database designed to help shoppers discover products faster and more efficiently. Rather than spending hours searching through multiple platforms manually, users can explore organized spreadsheets containing thousands of curated product listings across diverse categories.
              </p>
              <p>
                Each <strong>Sugargoo Spreadsheet</strong> entry typically includes direct product links, price ranges, size availability, and quality notes compiled by experienced international shoppers. These comprehensive databases have become an essential resource for anyone looking to navigate the vast world of global online shopping with confidence and ease.
              </p>
              <p>
                Whether you are hunting for the latest sneaker releases, trending streetwear pieces, luxury accessories, or everyday essentials, a well-maintained <strong>Sugargoo Spreadsheet</strong> can save you countless hours while helping you discover products you might never have found on your own.
              </p>
            </div>
            <a
              href="/article/what-is-sugargoo-spreadsheet"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full bg-secondary-100 hover:bg-secondary-200 text-secondary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Read Full Guide
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20displayed%20on%20clean%20laptop%20screen%20with%20minimal%20desk%20setup%2C%20warm%20beige%20background%20wall%2C%20soft%20morning%20sunlight%2C%20Scandinavian%20workspace%2C%20small%20potted%20plant%2C%20ceramic%20mug%2C%20editorial%20photography%2C%20neutral%20earth%20tones%2C%20clean%20composition&width=800&height=600&seq=sugargoo-whatis-v2&orientation=landscape"
                alt="Organized Sugargoo Spreadsheet product database on laptop screen"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}